import React from "react";
import { FormattedMessage } from 'react-intl';
import {
  Form,
  Button,
  Drawer,
  Row,
  Col,
  Input,
  Select,
  DatePicker,
  Spin,
  Upload
} from "antd";

import PersonAvatar from "../../../images/person-avatar.svg";
import UserAvatar from "../../../images/user-avatar.svg";
import libphonenumber from "google-libphonenumber";
import cw from "../../../utils/commonwords";

import moment from "moment";
import GPSInput from "./GPSInput";
import styles from "./styles.module.scss";
import "./styles.scss";
import ImgCrop from "../../ImgCrop";
import { API_URL } from "../../../config/environment";
import { getCookie } from "../../../utils/helpers";

let id = 0;
function getBase64(img, callback) {
  const reader = new FileReader();
  reader.addEventListener("load", () => callback(reader.result));
  reader.readAsDataURL(img);
}

export const PersonFormDrawer = Form.create({
  name: "person_add_form_drawer"
})(
  // eslint-disable-next-line
  class extends React.PureComponent {
    constructor(props) {
      super(props);
      this.state = {
        imageUrl: "",
        Photo: ""
      };
    }
    static defaultProps = {
      visible: false,
      maskClosable: true,
      destroyOnClose: true,
      width: "25%",
      drawerTitle: "Add person",
      // drawerTitle: this.props.intl.formatMessage(cw['addPerson']),
      okText: "Add",
      cancelButtonProps: {
        type: "link",
        "data-dfs-people-id": "person-add-form-drawer-cancel-link"
      },
      okButtonProps: {
        loading: false,
        "data-dfs-people-id": "person-add-form-drawer-add-button"
      },
      centered: true,
      countries: [],
      myGroups: [],
      customDataKeys: [],
      data: {},
      bodyStyle: {
        backgroundColor: "#f9f9f9",
        paddingBottom: 53,

        minHeight: "94%"
      },
      onCancel() { },
      onOk() { }
    };
    addCustomDataInput = () => {
      const { form } = this.props;
      const customDataKeys = form.getFieldValue("customDataKeys");
      const nextKeys = customDataKeys.concat(id++);
      form.setFieldsValue({
        customDataKeys: nextKeys
      });
    };
    removeCustomDataInput = k => {
      const { form } = this.props;
      const customDataKeys = form.getFieldValue("customDataKeys");
      if (customDataKeys.length === 0) {
        return;
      }
      id--;
      form.setFieldsValue({
        customDataKeys: customDataKeys.filter(key => key !== k)
      });
    };
    checkNumber = phone => {
      try {
        return libphonenumber.PhoneNumberUtil.getInstance().isPossibleNumber(
          libphonenumber.PhoneNumberUtil.getInstance().parse(phone, "")
        );
      } catch (error) {
        return false;
      }
    };

    isPhoneNumber = phone => {
      try {
        return libphonenumber.PhoneNumberUtil.getInstance().isValidNumber(
          libphonenumber.PhoneNumberUtil.getInstance().parse(phone, "")
        );
      } catch (error) {
        return false;
      }
    };
    checkPhoneNumber = async (rule, value, callback) => {
      if (!value) {
        callback();
      }
      var pattern = /^[0-9+]*$/;
      if (pattern.test(`${value}`) === false) {
        callback(
          this.props.intl.formatMessage(
            cw.formErrorMsgNotValidPhoneNumber
          )
        );
      }
      callback();
    };
    emailRequired = (rule, value, callback) => {
      const { form } = this.props;
      if(!form.getFieldValue("Email") && !form.getFieldValue("Phone Number")){
        callback("Email is required!");
      }else{
        callback()
      }
      
    };
    phoneRequired = (rule, value, callback) => {
      const { form } = this.props;
      if (!form.getFieldValue("Phone Number") && !form.getFieldValue("Email")){
        callback("Phone is required!");
      }else{
        callback()
      }

      
    };
    handleImageChange = info => {
      if (info.file.status === "uploading") {
        this.setState({ loading: true });
        return;
      }
      if (info.file.status === "done") {
        const { form } = this.props;

        getBase64(info.file.originFileObj, imageUrl =>
          this.setState({
            imageUrl,
            loading: false
          })
        );
        form.setFieldsValue({
          Photo: info.file.response.data || this.props.data["Photo"]
        });
      }
    };

    onCancel = () => {
      this.setState(
        {
          imageUrl: null
        },
        () => {
          this.props.onCancel();
        }
      );
    };
    imgError = ev => {
      ev.onerror = "";
      ev.target.src = `${UserAvatar}`;
      return true;
    };
    render() {
      const {
        visible,
        maskClosable,
        width,
        okButtonProps,
        cancelButtonProps,
        form,
        countries,
        myGroups,
        groups,
        onOk,
        customDataKeys,
        drawerTitle,
        data,
        bodyStyle,
        mode,
        fetchedGroupId,
        location,
        fetchingPerson
      } = this.props;

      const { getFieldDecorator, getFieldValue } = form;
      const formItemLayout = {
        labelCol: {
          lg: { span: 24 },
          xl: { span: 6 }
        },
        wrapperCol: {
          lg: { span: 24 },
          xl: { span: 18 }
        }
      };

      getFieldDecorator("customDataKeys", {
        initialValue: customDataKeys || []
      });
      const customDtKeys = getFieldValue("customDataKeys");
      id = customDtKeys.length;

      const lng = data["GPS Location"]
        ? data["GPS Location"].longitude
        : undefined;
      const lat = data["GPS Location"]
        ? data["GPS Location"].latitude
        : undefined;

      // const formItems =
      //   customDtKeys.length > 0 &&
      //   customDtKeys.map((k, index, array) => (
      //     <React.Fragment key={index}>
      //       <Col xs={24} sm={22} style={{ paddingLeft: 5 }}>
      //         <Form.Item required={false}>
      //           {getFieldDecorator(`CustomData[${k}]`, {
      //             rules: [
      //               {
      //                 required: true,
      //                 message: "Custom name and value are required"
      //               }
      //             ]
      //           })(<CustomDataInput />)}
      //         </Form.Item>
      //       </Col>
      //       <Col span={2} style={{ paddingLeft: 0, paddingRight: 0 }}>
      //         <Form.Item>
      //           <Icon
      //             className="dynamic-delete-button"
      //             type="close"
      //             onClick={() => this.removeCustomDataInput(k)}
      //           />
      //         </Form.Item>
      //       </Col>
      //     </React.Fragment>
      //   ));
      // console.log(fetchingPerson);
      return (

        <Drawer
          className="person-form-drawer"
          destroyOnClose={true}
          width={width}
          maskClosable={maskClosable}
          visible={visible}
          onClose={this.onCancel}
          bodyStyle={bodyStyle}
          title={
            <React.Fragment>
              <div className="ant-drawer-title">{drawerTitle}</div>
            </React.Fragment>
          }
        >
          <Row gutter={24}>
            <Col lg={24}> <Spin spinning={fetchingPerson}></Spin> </Col>
            <Col xs={24} sm={6}>
              <Form.Item
                style={{
                  marginTop: "-30px",
                  float: "right",
                  marginBottom: 0
                }}
              >
                {getFieldDecorator("Photo", {})(
                  <ImgCrop width={64} height={64}>
                    <Upload
                      name="photo"
                      listType="picture-card"
                      className="avatar-uploader"
                      showUploadList={false}
                      headers={{
                        "x-access-token": getCookie("user_token")
                      }}
                      action={`${API_URL}/persons/photos/uploads`}
                      onChange={this.handleImageChange}
                    >
                      {this.state.imageUrl ? (
                        <img
                          className="avatar-preview"
                          src={this.state.imageUrl}
                          alt="avatar"
                        />
                      ) : (
                        <React.Fragment>
                          {mode === "edit" && data["Photo"] ? (
                            <img
                              className="avatar-preview"
                              src={`${API_URL}/persons/photos/${data["Photo"]}`}
                              alt="avatar"
                              onError={this.imgError}
                            />
                          ) : (
                            <img
                              style={{ width: "3rem" }}
                              src={PersonAvatar}
                              alt="Person avatar"
                            />
                          )}
                        </React.Fragment>
                      )}
                    </Upload>
                  </ImgCrop>
                )}
              </Form.Item>
            </Col>
            <Col xl={9} lg={24} style={{ marginTop: "-1rem", paddingLeft: 5 }}>
              <Form.Item colon={true}>
                {getFieldDecorator("First Name", {
                  initialValue: data["First Name"] || data["First Name "],
                  rules: [
                    // { required: true },
                    { max: 25, message: this.props.intl.formatMessage(cw['CharsMax'], { value: 25 }) },
                    { min: 2, message: this.props.intl.formatMessage(cw['CharsMin'], { value: 2 }) }
                  ]
                })(
                  <Input
                    placeholder={this.props.intl.formatMessage(cw['FirstName'])} disabled={fetchingPerson}
                    data-dfs-people-id={"first-name-input"}
                    maxLength={25}
                  />
                )}
              </Form.Item>
            </Col>
            <Col xl={9} lg={24} style={{ marginTop: "-1rem" }}>
              <Form.Item colon={false}>
                {getFieldDecorator("Last Name", {
                  // validateTrigger: ['onBlur'],
                  initialValue: data["Last Name"] || data["Last Name "] || "",
                  rules: [
                    // { required: true },
                    { max: 25, message: this.props.intl.formatMessage(cw['CharsMax'], { value: 25 }) },
                    { min: 2, message: this.props.intl.formatMessage(cw['CharsMin'], { value: 2 }) }
                  ]
                })(
                  <Input
                    placeholder={this.props.intl.formatMessage(cw['LastName'])}
                    data-dfs-people-id={"last-name-input"}
                    maxLength={25} disabled={fetchingPerson}
                  />
                )}
              </Form.Item>
            </Col>
            <Col xs={24} sm={24}>
              <Form.Item colon={false} {...formItemLayout} required={true} label={<FormattedMessage id="Email" defaultMessage="Email" />}>
                {getFieldDecorator("Email", {
                  initialValue: data["Email"],
                  rules: [
                    { validator: this.emailRequired, trigger: 'onSubmit' },
                    { type: "email", message: this.props.intl.formatMessage(cw['InvalidEmail']) }
                  ]
                })(<Input data-dfs-people-id={"email-input"} disabled={fetchingPerson} />)}
              </Form.Item>
            </Col>
            <Col xs={24} sm={24}>
              <Form.Item
                required={true}
                colon={false}
                {...formItemLayout}
                label={<FormattedMessage id="Mobile" defaultMessage="Mobile" />}
              >
                {getFieldDecorator("Phone Number", {
                  initialValue: `${data["Phone Number"] || ''}`,
                  rules: [
                    // { required: true },
                    { max: 15, message: this.props.intl.formatMessage(cw['CharsMax'], { value: 15 }) },
                    { validator: this.phoneRequired, trigger: 'onSubmit' },
                    { validator: this.checkPhoneNumber, trigger: "onBlur" },
                    { min: 7, message: this.props.intl.formatMessage(cw['CharsMin'], { value: 7 }) }
                  ]
                })(
                  <Input autoFocus type={"number"} minLength={9} maxLength={15} disabled={fetchingPerson} data-dfs-people-id={"phone-number-input"} />
                )}
              </Form.Item>
            </Col>

            <Col xs={24} sm={24}>
              <Form.Item colon={false} {...formItemLayout} label={<FormattedMessage id="Occupation" defaultMessage="Occupation" />}>
                {getFieldDecorator("Occupation", {
                  initialValue: data["Occupation"],
                  rules: [
                    // { required: true, message: 'Occupation is required' },
                  ]
                })(<Input data-dfs-people-id={"occupation-input"} disabled={fetchingPerson} />)}
              </Form.Item>
            </Col>
            <Col xs={24} sm={24}>
              <Form.Item colon={false} {...formItemLayout} label={<FormattedMessage id="Country" defaultMessage="Country" />}>
                {getFieldDecorator("Country", {
                  initialValue: data["Country"]
                })(
                  <Select
                    style={{ width: "100%" }}
                    data-dfs-people-id={"country-select"}
                    showSearch disabled={fetchingPerson}
                    getPopupContainer={trigger => trigger.parentElement} 
                  >
                    {countries.map(country => (
                      <Select.Option
                        key={country.countryCode}
                        value={country.name}
                      >
                        {country.name}
                      </Select.Option>
                    ))}
                  </Select>
                )}
              </Form.Item>
            </Col>
            <Col xs={24} sm={24}>
              <Form.Item colon={false} {...formItemLayout} label={<FormattedMessage id="TownCity" defaultMessage="Town/City" />}>
                {getFieldDecorator("City", {
                  initialValue: data["City"],
                  rules: [
                    { min: 2, message: this.props.intl.formatMessage(cw['CharsMin'], { value: 2 }) }
                  ]
                })(<Input data-dfs-people-id={"town-input"} disabled={fetchingPerson} />)}
              </Form.Item>
            </Col>
            <Col xs={24} sm={24}>
              <Form.Item colon={false} {...formItemLayout} label={<span><FormattedMessage id="Address" defaultMessage="Address" /> 1</span>}>
                {getFieldDecorator("Address 1", {
                  initialValue: data["Address 1"],
                  rules: [
                    { min: 2, message: this.props.intl.formatMessage(cw['CharsMin'], { value: 2 }) }
                  ]
                })(<Input data-dfs-people-id={"address1-input"} disabled={fetchingPerson} />)}
              </Form.Item>
            </Col>
            <Col xs={24} sm={24}>
              <Form.Item colon={false} {...formItemLayout} label={<span><FormattedMessage id="Address" defaultMessage="Address" /> 2</span>}>
                {getFieldDecorator("Address 2", {
                  initialValue: data["Address 2"],
                  rules: [
                    { min: 2, message: this.props.intl.formatMessage(cw['CharsMin'], { value: 2 }) }
                  ]
                })(<Input data-dfs-people-id={"address2-input"} disabled={fetchingPerson} />)}
              </Form.Item>
            </Col>
            {mode === "create" && (
              <Col xs={24} sm={24}>
                <Form.Item colon={false} {...formItemLayout} label={<FormattedMessage id="Group" defaultMessage="Group" />}>
                  {getFieldDecorator("groups", {
                    initialValue:
                      mode === "create" && location.pathname.includes("/groups")
                        ? fetchedGroupId
                        : groups || ""
                  })(
                    <Select style={{ width: "100%" }} disabled={fetchingPerson}  getPopupContainer={trigger => trigger.parentElement}>
                      <Select.Option key="everyone" value="">
                        <FormattedMessage id="Everyone" defaultMessage="Everyone" />
                      </Select.Option>
                      {myGroups.map(opt => (
                        <Select.Option key={opt.uuid} value={opt.uuid}>
                          {opt.name}
                        </Select.Option>
                      ))}
                    </Select>
                  )}
                </Form.Item>
              </Col>
            )}

            <Col xs={24} sm={24}>
              <Form.Item colon={false} {...formItemLayout} label={<FormattedMessage id="IDNumber" defaultMessage="ID Number" />}>
                {getFieldDecorator("Id Number", {
                  initialValue:data["Id Number"] ? data["Id Number"].toString()  : '',
                  rules: [
                    { min: 2, message: this.props.intl.formatMessage(cw['CharsMin'], { value: 2 }) }
                  ]
                })(
                  <Input data-dfs-people-id={"identification-number-input"} disabled={fetchingPerson} />
                )}
              </Form.Item>
            </Col>
            <Form.Item style={{ visibility: "hidden" }}>
              {getFieldDecorator("Photo", {
                initialValue: data["Photo"]
              })(<Input type="hidden" data-dfs-people-id={"photo-input"} disabled={fetchingPerson} />)}
            </Form.Item>
            <Col xs={24} sm={24}>
              <Form.Item colon={false} {...formItemLayout} label={<FormattedMessage id="Title" defaultMessage="Title" />}>
                {getFieldDecorator("Title", {
                  initialValue: data["Title"],
                  rules: [
                    { min: 2, message: this.props.intl.formatMessage(cw['CharsMin'], { value: 2 }) }
                  ]
                })(
                  <Select
                    style={{ width: "100%" }}
                    data-dfs-people-id={"title-select"}
                    showSearch disabled={fetchingPerson} 
                    getPopupContainer={trigger => trigger.parentElement}   
                  >
                    <Select.Option value="Mr.">Mr.</Select.Option>
                    <Select.Option value="Mrs.">Mrs.</Select.Option>
                    <Select.Option value="Miss">Miss</Select.Option>
                    <Select.Option value="Dr."> Dr.</Select.Option>
                    <Select.Option value="Prof.">Prof.</Select.Option>
                    <Select.Option value="Other">Other</Select.Option>
                  </Select>
                )}
              </Form.Item>
            </Col>
            <Col xs={24} sm={24}>
              <Form.Item colon={false} {...formItemLayout} label={<FormattedMessage id="Gender" defaultMessage="Gender" />}>
                {getFieldDecorator("Gender", {
                  initialValue: data["Gender"],
                  rules: [
                    { min: 1, message: this.props.intl.formatMessage(cw['CharsMin'], { value: 1 }) }
                  ]
                })(
                  <Select
                    style={{ width: "100%" }}
                    data-dfs-people-id={"gender-select"}
                    showSearch disabled={fetchingPerson}
                    getPopupContainer={trigger => trigger.parentElement} 
                  >
                    <Select.Option value="Male">Male</Select.Option>
                    <Select.Option value="Female">Female</Select.Option>
                    <Select.Option value="Other">Other</Select.Option>
                  </Select>
                )}
              </Form.Item>
            </Col>
            <Col xs={24} sm={24}>
              <Form.Item
                colon={false}
                {...formItemLayout}
                label={<FormattedMessage id="DateOfBirth" defaultMessage="Date Of Birth" />}
              >
                {getFieldDecorator("Date of Birth", {
                  initialValue: data["Date of Birth"]
                    ? moment(data["Date of Birth"])
                    : null
                })(
                  <DatePicker disabled={fetchingPerson}
                    format={"YYYY-MM-DD"}
                    placeholder=""
                    data-dfs-people-id={"date-of-birth-input"}
                    style={{ width: "100%" }}
                    getCalendarContainer={trigger => trigger.parentElement}
                    disabledDate={current =>
                      current && current > moment().startOf("end")
                    }
                  />
                )}
              </Form.Item>
            </Col>

            {/* <Col xs={24} sm={6} style={{ paddingRight: 0 }}>
            <Form.Item colon={false} label="GPS" />
          </Col> */}
            <Col xs={24} sm={24}>
              <Form.Item colon={false} {...formItemLayout} label={<FormattedMessage id="GPS" defaultMessage="GPS" />}>
                {getFieldDecorator("GPS Location", {
                  initialValue: { latitude: lat, longitude: lng }
                })(<GPSInput disabled={fetchingPerson} />)}
              </Form.Item>
            </Col>
            {/*
            <Col xs={24} sm={6} style={{ paddingRight: 5 }}>
              <Form.Item colon={false} label="Custom Fields" />
            </Col>

            <Col xs={24} sm={18} style={{ paddingLeft: 0, paddingRight: 0 }}>
              {formItems ? (
                formItems
              ) : (
                <Col xs={24} sm={22} style={{ paddingLeft: 5 }}>
                  <Form.Item>
                    <small>Add custom fields here</small>
                  </Form.Item>
                </Col>
              )}
              {id <= 4 && (
                <Col span={24} style={{ paddingRight: 0, paddingLeft: 0 }}>
                  <Form.Item>
                    <Button
                      style={{ paddingLeft: 0 }}
                      type="link"
                      icon="plus"
                      onClick={() => this.addCustomDataInput()}
                    >
                      Add new field
                    </Button>
                  </Form.Item>
                </Col>
              )}
            </Col> */}
          </Row>

          <div className={styles.drawerfooter}>
            <div />
            <div>
              <Button {...cancelButtonProps} onClick={this.onCancel}>
                <FormattedMessage id="Cancel" defaultMessage="Cancel" />
              </Button>
              <Button
                {...okButtonProps}
                onClick={e => onOk(e, this.state.Photo)}
                type="primary"
              >
                {mode === "edit" ? <FormattedMessage id="Button.Update" defaultMessage="Update" /> : <FormattedMessage id="Button.Save" defaultMessage="Save" />}
              </Button>
            </div>
          </div>
        </Drawer>
        // </Spin>
      );
    }
  }
);
